/**
 * The snap grid of a slideshow sheet, shared by the pictures and the blocks
 * placed on it. Everything is in percent of the sheet: x of its width, y of
 * its height.
 */

/** Grid step, in sheet percent. */
export const SHEET_GRID = 5;

/** Sheet percent within which an edge snaps to a guide rather than the grid. */
export const SNAP_DISTANCE = 1.2;

const round = (value) => Math.round(value * 100) / 100;

/**
 * Where things snap besides the grid: the sheet's edges and middle, each
 * page's edges and middle (so the gutter too).
 */
export function sheetGuides({ single = true, pageWidth = 50 } = {}) {
    const x = single ? [0, 50, 100] : [0, pageWidth / 2, pageWidth, 50, 100 - pageWidth, 100 - pageWidth / 2, 100];
    return { x: [...new Set(x.map(round))], y: [0, 50, 100] };
}

/**
 * The shift that puts one of `edges` (positions that travel together) on a
 * guide within reach, or else on the grid, which carries on past the sheet.
 * With `lead` only the first edge goes onto the grid; otherwise whichever
 * edge is nearest a grid line.
 *
 * @param {number[]} edges
 * @param {number[]} guides
 * @returns {{ shift: number, line: number|null, guide: boolean }}
 */
export function snapEdges(edges, guides, { grid = SHEET_GRID, distance = SNAP_DISTANCE, lead = false } = {}) {
    let best = null;
    edges.forEach((edge) => guides.forEach((guide) => {
        const shift = guide - edge;
        if (Math.abs(shift) <= distance && (!best || Math.abs(shift) < Math.abs(best.shift))) {
            best = { shift, line: guide, guide: true };
        }
    }));
    if (best) return best;
    (lead ? edges.slice(0, 1) : edges).forEach((edge) => {
        const line = round(Math.round(edge / grid) * grid);
        const shift = line - edge;
        if (!best || Math.abs(shift) < Math.abs(best.shift)) best = { shift, line, guide: false };
    });
    return best || { shift: 0, line: null, guide: false };
}
